// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"23":"6e520e96","173":"a64d7126","449":"e525f90a"}[chunkId] + ".chunk.css";
};